import React from 'react';

const SvgIcon: React.FC<any> = ({
  Icon,
  width = 24,
  height = 24,
  fill = 'currentColor',
  className,
  ...rest
}) => {
  return <Icon width={width} height={height} fill={fill} className={className} {...rest} />;
};

export default SvgIcon;